const cf = (process.env.NODE_ENV === "development") ? require("./local.config") : require("./prod.config");

export default cf.default;
